import AdvancedController from "./advanced-controller"

export default class SearchFieldController extends AdvancedController {

  static targets = ['searchField', "searchClear"];

  connect() {
    super.connect();

    this.showSearchClear();
  }

  onSearchClear(e) {
    e.preventDefault();
    this.searchFieldTarget.value = ""
    this.searchFieldTarget.focus()
    this.showSearchClear();
  }

  showSearchClear() {
    if (this.searchFieldTarget.value.length == 0) {
      this.searchClearTarget.classList.add("-hidden");
    } else {
      this.searchClearTarget.classList.remove("-hidden");
    }
  }
}
